import React from 'react';
import { Box } from '@mui/material';
import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseLongContent: React.FC<{
    children: React.ReactNode;
  }> = ({ children }) => (
    <Box
      data-testid='mui-card-desktop__right-content'
      sx={{
        gap: spaces.md,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
  
export default MuiCardBaseLongContent;
